import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { I18nProvider } from "@/contexts/I18nContext";
import { SettingsProvider, useSettings } from "@/contexts/SettingsContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import TradeRoom from "@/pages/TradeRoom";
import Wallet from "@/pages/Wallet";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Referrals from "@/pages/Referrals";
import SharedTrade from "@/pages/SharedTrade";
import Leaderboard from "@/pages/Leaderboard";
import SocialTrading from "@/pages/SocialTrading";
import Portfolio from "@/pages/Portfolio";
import Tournaments from "@/pages/Tournaments";
import TraderProfile from "@/pages/TraderProfile";
import NotFound from "@/pages/NotFound";

function SiteFooter() {
  const { settings, loading } = useSettings();
  return (
    <footer className="border-t border-line py-6 px-6 text-center text-xs text-dim font-mono mt-auto">
      {!loading && (settings?.footer_text || "IQTrade · Educational Trading Simulator · Not Financial Advice")}
    </footer>
  );
}

function AppRoutes() {
  return (
    <div className="flex flex-col min-h-screen bg-app text-white">
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/trade" element={<ProtectedRoute><TradeRoom /></ProtectedRoute>} />
          <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
          <Route path="/leaderboard" element={<ProtectedRoute><Leaderboard /></ProtectedRoute>} />
          <Route path="/social" element={<ProtectedRoute><SocialTrading /></ProtectedRoute>} />
          <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
          <Route path="/tournaments" element={<ProtectedRoute><Tournaments /></ProtectedRoute>} />
          <Route path="/trader/:id" element={<ProtectedRoute><TraderProfile /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/share/trade/:id" element={<SharedTrade />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <SiteFooter />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <ThemeProvider>
          <I18nProvider>
          <AuthProvider>
            <BrowserRouter>
              <AppRoutes />
              <Toaster theme="dark" position="top-right" />
            </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
      </ThemeProvider>
      </SettingsProvider>
    </div>
  );
}
